// /store/state.js
export default () => ({
  counter: 0,
  application: {},
  categories: [],
  manufacturers: [],
  catalogStatus: "idle",
  catalogError: null,
  localStories: null
})
